import React, { useState } from "react";
import PropTypes from "prop-types";

import { Switch } from "@mui/material";

function ControlledSwitch(props) {
  const [controlledvalue, setControlledValue] = useState(props.checked ?? false);

  let value;
  if (props.controlled) {
    value = controlledvalue;
  } else {
    value = props.checked;
  }

  const convertToOutput = (value) => {
    if (typeof props.checked === "string") {
      return value ? "1" : "0";
    } else if (typeof props.checked === "number") {
      return value ? 1 : 0;
    } else {
      return value;
    }
  };

  const convertToBoolean = (value) => {
    return value === 1 || value === "1" || value === true;
  };

  return (
    <>
      <input key={"maininput"} name={props.name} type={"hidden"} value={convertToOutput(value)} />

      <Switch
        checked={convertToBoolean(value)}
        color={props.color}
        id={props.id}
        inputProps={props.inputProps}
        onChange={(e) => {
          if (props.controlled) {
            setControlledValue(convertToOutput(e.target.checked));
          }
          props.onHandleValue(convertToOutput(e.target.checked));
        }}
        {...props.InputProps}
      />
    </>
  );
}

ControlledSwitch.defaultProps = {
  controlled: true,
  color: "primary",
};

ControlledSwitch.propTypes = {
  name: PropTypes.string,
  color: PropTypes.string,
  onHandleValue: PropTypes.func.isRequired,
  controlled: PropTypes.bool,
  checked: PropTypes.oneOf([Number, String, Boolean]),
};

export default ControlledSwitch;
